import config from "../../../config";
import moment from "moment";

export default {
    timer: 0,
    data: {
        loading: false,
        error: false,
        noContent: false,
        message: undefined
    },
    arrivalRules: {
        loading: false,
        error: false,
        noContent: false,
        item: undefined
    },
    list: {
        loading: false,
        noContent: false,
        error: false,
        items: undefined,
        predicate: "pendingRequests",
        predicateList: [
            "pendingRequests",
            "name",
            "updatedAt",
            "site"
        ],
        limit: 20,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        display: 'current',
        displayOptions: ['all', 'current', 'historical'],
        orderList: [
            "asc",
            "desc"
        ],
        order: "desc"
    },
    allocations: {
        loading: false,
        noContent: false,
        error: false,
        items: undefined,
        years: {
            current: moment().startOf('year').format('YYYY'),
            years: [
                moment().startOf('year').format('YYYY'),
                moment().add(1, 'years').startOf('year').format('YYYY'),
                moment().add(2, 'years').startOf('year').format('YYYY')
            ]
        },
        limit: 10,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        orderList: [
            "asc",
            "desc"
        ],
        order: "asc"
    },
    allocationsMerged: {
        loading: false,
        noContent: false,
        error: false,
        items: undefined
    },
    filters: {
        loading: false,
        error: false,
        sites: {},
        suppliers: {},
        selected: {
            site: undefined,
            accommodation: undefined,
            supplier: undefined
        },
    },
    form: {
        open: true,
        defaultRow: {
            from: undefined,
            to: undefined,
            type: "ALLOTMENT",
            units: undefined,
            releaseType: undefined,
            releaseMethod: 'days',
            releaseDays: undefined,
            releaseDate: undefined
        },
        rows: [{
            from: null,
            to: null,
            type: "ALLOTMENT",
            units: null,
            releaseType: "",
            releaseMethod: "days",
            releaseDays: null,
            releaseDate: null,
        }],
        filters: {
            sites: {},
            loading: false,
            error: false,
            selected: {
                site: undefined,
                accommodation: undefined
            }
        },
        allocations: {
            loading: false,
            error: false,
        },
        validator: {
            error: false,
            messages: undefined
        },
        submit: {
            submitted: false,
            accepted: false,
            cancelled: false,
            alerts: null
        }
    },
    calendar: {
        loading: false,
        error: false,
        from: undefined,
        to: undefined,
        startIndex: undefined,
        fullCalendar: false,
        showInfo: false,
        infoPage: 1,
        startMonth: 3,
        endMonth: 9,
        items: undefined,
        display: {
            choices: ['full', 'months'],
            choice: 'months'
        }
    },
    allocationPeriod: {
        from: config.business.SEASON_DATE_START,
        to: config.business.SEASON_DATE_END
    },
    accommodation: {
        id: undefined,
        siteId: undefined,
    },
    modal: {
        open: false,
        loading: undefined,
        noContent: undefined,
        error: undefined,
        success: false,
        blocked: false,
        adding: false,
        list: {
            limit: 3,
            page: 1,
        },
        overlay: {
            loading: false,
            error: false,
            success: false,
            open: false,
            message: undefined,
            allocation: {
                item: {
                    comment: undefined
                },
                original: {
                    comment: undefined
                },
                changes: false,
            },
            validator: {
                error: false,
                messages: undefined
            },
            bookings: {
                page: 1,
                limit: 3
            }
        }
    },
    allocationPage: {
        tips: [
            {
                title: 'tips.allocationPage.sort.title',
                body: 'tips.allocationPage.sort.body'
            },
            {
                title: 'tips.allocationPage.site.title',
                body: 'tips.allocationPage.site.body'
            },
            {
                title: 'tips.allocationPage.update.title',
                body: 'tips.allocationPage.update.body'
            },
            {
                title: 'tips.allocationPage.updateBy.title',
                body: 'tips.allocationPage.updateBy.body'
            }
        ]
    },
    manageAllocationPage: {
        tips: [
            {
                title: 'tips.manageAllocationPage.info.title',
                body: 'tips.manageAllocationPage.info.body'
            },
            {
                title: 'tips.manageAllocationPage.select.title',
                body: 'tips.manageAllocationPage.select.body'
            },
            {
                title: 'tips.manageAllocationPage.extra.title',
                body: 'tips.manageAllocationPage.extra.body'
            },
            {
                title: 'tips.manageAllocationPage.year.title',
                body: 'tips.manageAllocationPage.year.body'
            },
            {
                title: 'tips.manageAllocationPage.accommodation.title',
                body: 'tips.manageAllocationPage.accommodation.body'
            },
            {
                title: 'tips.manageAllocationPage.display.title',
                body: 'tips.manageAllocationPage.display.body'
            },
            {
                title: 'tips.manageAllocationPage.modal.title',
                body: 'tips.manageAllocationPage.modal.body'
            },
            {
                title: 'tips.manageAllocationPage.overview.title',
                body: 'tips.manageAllocationPage.overview.body'
            }
        ]
    },
    request: {
        editMode: false,
        loading: false,
        error: false,
        items: {
            pending: [],
            approved: [],
            denied: [],
            modified: []
        },
        item: undefined,
        itemIndex: undefined,
        indices: [],
        limit: 3,
        page: 1,
        predicate: 'pending',
        predicates: ['pending', 'approved', 'denied', 'modified']
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/allocation/state.js